export const modal = () => {
  return {
    '.elmo-layout__main-menu, .elmo-layout__main-header': {
      zIndex: 0,
    },
  };
};
